// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background-color: whitesmoke;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas: ". logo links";
  justify-content: flex-end;
  align-items: center;
  height: 80px;
  padding: 20 20px;
  z-index: 1000;
}
.navbar img {
  max-height: 50px;
}

.nav-img {
  padding: 4px;
  height: 60px;
  max-width: 60px;
}

.nav-img:hover {
  cursor: pointer;
}

.nav-img-container {
  text-decoration: none;
  border-radius: 3px;
  color: black;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 70px;
  padding: 0 8px 0 8px;
}
.nav-img-container:hover {
  cursor: pointer;
  background-color: white;
  border-radius: 5px;
}

.nav-img-container:hover {
  cursor: pointer;
}

.nav-img-container:hover {
  text-decoration: none;
  color: black;
}

.logo-container {
  text-decoration: none;
  grid-column: 2/3;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo-container .brand {
  display: flex;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  width: 100%;
  margin: auto;
}
.logo-container .brand .brand-name1 {
  color: #1d0f40;
}
.logo-container .brand .brand-name2 {
  padding-left: 8px;
  color: #8dc63f;
}

.links-container {
  margin-right: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}

.select {
  background-color: rgb(238, 238, 238);
}`, "",{"version":3,"sources":["webpack://./src/routes/navbar/navbar.styles.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,aAAA;EACA,kCAAA;EACA,mCAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AAAF;AAEE;EACE,eAAA;EACA,uBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,qBAAA;EACA,YAAA;AADF;;AAIA;EACE,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AADJ;AAEI;EACE,cAAA;AAAN;AAEI;EACE,iBAAA;EACA,cAAA;AAAN;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAFF;;AAKA;EACE,oCAAA;AAFF","sourcesContent":[".navbar {\n  background-color: whitesmoke;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-areas: \". logo links\";\n  justify-content: flex-end;\n  align-items: center;\n  height: 80px;\n  padding: 20 20px;\n  z-index: 1000;\n\n  img {\n    max-height: 50px;\n  }\n}\n\n.nav-img {\n  padding: 4px;\n  height: 60px;\n  max-width: 60px;\n}\n\n.nav-img:hover {\n  cursor: pointer;\n}\n\n.nav-img-container {\n  text-decoration: none;\n  border-radius: 3px;\n  color: black;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  max-width: 70px;\n  padding: 0 8px 0 8px;\n\n  &:hover {\n    cursor: pointer;\n    background-color: white;\n    border-radius: 5px;\n  }\n}\n\n.nav-img-container:hover {\n  cursor: pointer;\n}\n\n.nav-img-container:hover {\n  text-decoration: none;\n  color: black;\n}\n\n.logo-container {\n  text-decoration: none;\n  grid-column: 2 / 3;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .brand {\n    display: flex;\n    justify-content: center;\n    font-size: 30px;\n    font-weight: bold;\n    width: 100%;\n    margin: auto;\n    .brand-name1 {\n      color: #1d0f40;\n    }\n    .brand-name2 {\n      padding-left: 8px;\n      color: #8dc63f;\n    }\n  }\n}\n\n.links-container {\n  margin-right: 30px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 20px;\n}\n\n.select {\n  background-color: rgb(238, 238, 238);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
